import { createSelector, DefaultProjectorFn, MemoizedSelector } from '@ngrx/store';
import { IDashboardState, IState } from '../states/dashboard';

function createExceptionsSelectors(
  dashboardFeatureSelector: MemoizedSelector<IState, IDashboardState, DefaultProjectorFn<IDashboardState>>,
) {
  const selectSubsection = createSelector(
    dashboardFeatureSelector,
    (state: IDashboardState, props: { subsectionName: string }) => state.exceptions[props.subsectionName],
  );
  return {
    selectSubsection,
  };
}

export default createExceptionsSelectors;
